<template>
  <div class="accessibility-statement" dir="rtl">
    <div class="container">
      <h1>הצהרת נגישות</h1>
      
      <p><strong>אתר זה מופעל על ידי עוסק פטור.</strong></p>
      
      <p>בהתאם לתקנות שוויון זכויות לאנשים עם מוגבלות (התאמות נגישות לשירות), האתר פטור מחובת הנגשה בשל היקף פעילותו והיותו עוסק פטור.</p>
      
      <p>עם זאת, נעשה מאמץ להציג את תכני האתר בצורה ברורה ונוחה ככל האפשר לכלל המשתמשים.</p>
      
      <p>אם נתקלתם בקושי בגלישה באתר או בתוכן שאינו נגיש, ניתן לפנות אלינו ואנו נשתדל לסייע ככל שניתן.</p>
      
      <div class="contact-info">
        <h3>פרטי יצירת קשר:</h3>
        <ul>
          <li><strong>שם:</strong>ליאור תמם</li>
          <li><strong>טלפון:</strong> <a href="tel:+972537002122">053-7002122</a></li>
          <li><strong>דוא״ל:</strong> <a href="mailto:admin@yaeltamam.com">admin@yaeltamam.com</a></li>
        </ul>
      </div>
      
      <p class="update-date"><strong>תאריך עדכון ההצהרה:</strong> 03.01.2026</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccessibilityStatement'
}
</script>

<style scoped>
.accessibility-statement {
  padding: 40px 20px;
  background: #f8f9fa;
  min-height: 60vh;
}

.container {
  max-width: 800px;
  margin: 0 auto;
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

h1 {
  color: #2c3e50;
  margin-bottom: 30px;
  text-align: center;
}

h3 {
  color: #34495e;
  margin: 25px 0 15px 0;
}

p {
  line-height: 1.6;
  margin-bottom: 15px;
  color: #2c3e50;
}

.contact-info {
  background: #ecf0f1;
  padding: 20px;
  border-radius: 5px;
  margin: 25px 0;
}

.contact-info ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.contact-info li {
  margin: 10px 0;
  padding: 5px 0;
}

.contact-info a {
  color: #3498db;
  text-decoration: none;
}

.contact-info a:hover {
  text-decoration: underline;
}

.update-date {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #bdc3c7;
  font-style: italic;
  text-align: center;
}

@media (max-width: 768px) {
  .accessibility-statement {
    padding: 20px 10px;
  }
  
  .container {
    padding: 20px;
  }
}
</style>